import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GetConfigOrcamentoResponse } from '../../responses/vendas/get-config-orcamento.response';
import { ConfigOrcamentoLookupsResponse } from '../../responses/vendas/config-orcamento-lookups.response';
import { ConfigOrcamentoRequest } from '../../requests/vendas/config-orcamento.request';

@Injectable({
    providedIn: 'root',
})
export class ConfigOrcamentoService extends CommonService {
    private readonly apiUrl: string = environment.urlApiVendas + 'ConfigOrcamento';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public get(): Observable<GetConfigOrcamentoResponse> {
        return this.httpClient
            .get<GetConfigOrcamentoResponse>(this.apiUrl, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public getLookups(): Observable<ConfigOrcamentoLookupsResponse> {
        return this.httpClient
            .get<ConfigOrcamentoLookupsResponse>(`${this.apiUrl}/lookups`, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public update(id: number, request: ConfigOrcamentoRequest): Observable<GetConfigOrcamentoResponse> {
        const url = `${this.apiUrl}/idConfigOrcamento/${id}`;
        return this.httpClient
            .put<GetConfigOrcamentoResponse>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
